<template>
  <div class="notice">
    <header-bar :name="'首页'"></header-bar>
    <div class="content">
      <div>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: center;
            widows: 0;
            orphans: 0;
            font-size: 16pt;
            line-height: 1.2;
          "
        >
          <span style="font-family: '仿宋'; font-weight: bold"
            >“闪亮的青春”</span
          ><span style="font-family: '仿宋'; font-weight: bold">Vlog</span
          ><span style="font-family: '仿宋'; font-weight: bold">/</span
          ><span style="font-family: '仿宋'; font-weight: bold">Plog</span
          ><span style="font-family: '仿宋'; font-weight: bold">征集活动</span
          ><span style="font-family: '仿宋'; font-weight: bold">指导手册</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-indent: 24pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'">2022年悄悄来到了我们的身边</span
          ><span style="font-family: '仿宋'">，</span
          ><span style="font-family: '仿宋'">而</span
          ><span style="font-family: '仿宋'">志愿者小伙伴们</span
          ><span style="font-family: '仿宋'">仍</span
          ><span style="font-family: '仿宋'"
            >在地球的每一个角落，为传播中国语言及文化正在默默的努力工作着，</span
          ><span style="font-family: '仿宋'"
            >工作和生活虽然日复一日，看似循环往复，但我们的青春</span
          ><span style="font-family: '仿宋'">正</span
          ><span style="font-family: '仿宋'">在这往复的</span
          ><span style="font-family: '仿宋'">志愿</span
          ><span style="font-family: '仿宋'">生</span
          ><span style="font-family: '仿宋'">活和工作中闪闪发亮。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-indent: 24pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'"
            >青春转瞬即逝，为更好地记录我们闪亮的青春，请</span
          ><span style="font-family: '仿宋'">拿出你的手机，用</span
          ><span style="font-family: '仿宋'">Vlog</span
          ><span style="font-family: '仿宋'">或</span
          ><span style="font-family: '仿宋'">Plog</span
          ><span style="font-family: '仿宋'">的方式将</span
          ><span style="font-family: '仿宋'">“它们”</span
          ><span style="font-family: '仿宋'">进行记录，</span
          ><span style="font-family: '仿宋'"
            >并打开微信，关注国际中文教师志愿者俱乐部公众号，从公告中</span
          ><span style="font-family: '仿宋'">Vlog&amp;Plog</span
          ><span style="font-family: '仿宋'">征集</span
          ><span style="font-family: '仿宋'"
            >中上传你的短视频和图片故事，让更多的人认识你，了解你的故事，也让这份快乐永远驻足在我们“闪亮的青春”里。</span
          >
        </p>
        <ol type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 41pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在微信中找到“国际中文教师志愿者俱乐部公众号”</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.001.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="2" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 41pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在公众号中打开</span><span>“公告”点击“</span
            ><span>Vlog&amp;Plog</span><span>征集”</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.002.png"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="3" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 41pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span
              >进入“闪亮的青春”志愿者短视频与图片故事征集大赛，并点击“登录”按钮。</span
            >
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.003.jpeg"
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="4" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 41pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>创建账户，并登录账户。</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.004.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="5" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 41pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>登录完成后，点击作品提交</span><span>.</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.005.jpeg"
            alt="C:\Users\Home\AppData\Local\Microsoft\Windows\INetCache\Content.Word\03.png"
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: left;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            margin-bottom: 10px;
          "
        >
          <span style="font-family: '仿宋'; font-weight: bold">I．</span
          ><span style="font-family: '仿宋'; font-weight: bold"
            >短视频作品提交：</span
          >
        </p>
        <ol type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 59pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在完成</span><span>登录点击作品提交后，</span
            ><span>选择“短</span><span>视频</span><span>”</span
            ><span>上传，</span><span>点击“+”按钮</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'"
            >添加视频从移动设备或电脑端本地选择需要参赛的视频文件，在选择视频文件</span
          ><span style="font-family: '仿宋'">完成后</span
          ><span style="font-family: '仿宋'">，点击最下方“</span
          ><span style="font-family: '仿宋'">上传</span
          ><span style="font-family: '仿宋'">”按钮</span
          ><span style="font-family: '仿宋'">。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.006.jpeg"
            alt="C:\Users\Home\AppData\Local\Microsoft\Windows\INetCache\Content.Word\04.png"
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="2" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 59pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span
              >在点击上传后，会经历0%-100%上传的过程，请耐心等待，在出现100%</span
            ><span>字样后，点击“下一步”。</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.007.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="3" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在视频作品上</span><span>传完成</span
            ><span
              >后，进入信息填写页面，请上传标题图片（可从视频中截取图片），填写作品的标题、作品的描述（介绍）、拍摄的时间、拍摄的国家，最后选择作品的分类和话题。信息填写将用三张图进行指导</span
            >
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.008.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-left: 42.1pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'">信息指导图-1</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.009.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-left: 42.1pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'">信息指导图-2</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.010.png"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-left: 42.1pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'">信息指导图-3</span>
        </p>
        <ol start="4" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>最后一步也是最重要的一步，就是将您上</span><span>传好的</span
            ><span>作品</span><span style="font-weight: bold">点击“参赛”</span
            ><span
              >按钮，这样审核的老师会在一天左右的时间进行整体审核，并在审核完成后将您的作品更新至活动的首页，由网友进行推。</span
            >
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.011.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.012.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-left: 42pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            margin-bottom: 10px;
          "
        >
          <span style="font-family: '仿宋'; font-weight: bold"
            >II.图片故事作品提交</span
          >
        </p>
        <ol type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 59pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在完成登录点击作品提交后，选择“图片故事”上传，</span
            ><span>点击“+”按钮</span
            ><span
              >，与短视频上传不同，“图片故事”需要先填写作品相关的信息，作品标题、作品描述、拍摄时间、拍摄国家，并选择作品的分类和话题。</span
            >
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-left: 60pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'">&#xa0;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.013.jpeg"
            alt="C:\Users\Home\AppData\Local\Microsoft\Windows\INetCache\Content.Word\11.png"
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.014.png"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p  style="margin: 0pt; padding-left: 0pt">
          <p
            style="
              text-align: left;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span
              >在填写完成作品信息后，进行图片作品的上传，从移动设备或电脑端本地上传</span
            ><span>3张及以上图片，并往复点击“添加图片”和“上传”按钮。</span>
            <span class="imgCon">
              <img
                src="../img/m/guide/adhka-yx1zn.015.jpeg"
                alt=""
                style="
                  -aw-left-pos: 0pt;
                  -aw-rel-hpos: column;
                  -aw-rel-vpos: paragraph;
                  -aw-top-pos: 0pt;
                  -aw-wrap-type: inline;
                "
              />
            </span>
            
          </p>
          <p
            style="
              margin-left: 59pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在图片作品分别上</span><span>传完成</span
            ><span>后，将作品中每幅图片填写图片的描述（描</span
            ><span
              >述可相同）；在图片描述完成后，选择一张图片为封面图片（封面图片将成为图片故事的标题图片在网络专题中展示）</span
            >
          </p>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.016.png"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="4" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 59pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>在全部图片上传完成，并填写</span><span>好图片</span
            ><span>描述、</span><span>选择</span
            ><span>好封面图片后，点击最下方“上传”按钮。</span>
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.017.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <ol start="5" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              margin-left: 59pt;
              text-align: justify;
              widows: 0;
              orphans: 0;
              padding-left: 1pt;
              font-family: '仿宋';
              font-size: 12pt;
            "
          >
            <span>最后一步也是最重要的一步，就是将您上</span><span>传好的</span
            ><span>作品点击“参赛”按</span
            ><span
              >钮，这样审核的老师会在一天左右的时间进行整体审核，并在审核完成后将您的作品更新至活动的首页，由网友进行主推。</span
            >
          </li>
        </ol>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.018.jpeg"
            alt=""
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
            text-align: center;
          "
        >
          <img
            src="../img/m/guide/adhka-yx1zn.019.png"
            style="
              -aw-left-pos: 0pt;
              -aw-rel-hpos: column;
              -aw-rel-vpos: paragraph;
              -aw-top-pos: 0pt;
              -aw-wrap-type: inline;
            "
          />
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'"
            >使用电脑端进行作品上传的小伙伴们，可以通过链接：</span
          ><span
              style="
                font-family: '仿宋';
                color: #0000ff;
                word-break: break-all;
              "
              >https://collection2021.chineseplus.net/</span
            ><span style="font-family: '仿宋'"> 进行作品上传，上</span
          ><span style="font-family: '仿宋'">传方式</span
          ><span style="font-family: '仿宋'">与移动端相同。 </span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-indent: 24pt;
            text-align: justify;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="font-family: '仿宋'"
            >亲爱的志愿者小伙伴们，在你们忙碌的工作和生活之余，请拿出你们的相机</span
          ><span style="font-family: '仿宋'">或</span
          ><span style="font-family: '仿宋'">手机，记录下</span
          ><span style="font-family: '仿宋'">你们</span
          ><span style="font-family: '仿宋'">“闪亮的青春”</span
          ><span style="font-family: '仿宋'"
            >，在我们此次志愿者短视频与图片故事大赛中，留下你精彩的作品，我们期望了解你的志愿生活，我们期待你的优秀作品，我们在这儿等这</span
          ><span style="font-family: '仿宋'">你</span
          ><span style="font-family: '仿宋'">！</span>
        </p>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import headerBar from "./common/headerBar";
export default {
  name: "notice",
  data() {
    return {};
  },
  components: {
    headerBar,
  },
  methods: {
    routerTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
  width: 100%;
  height: 100%;
  margin: 0 auto 0;
  text-align: center;
  font-size: 20px;
  text-align: left;
  overflow: hidden;
  background-color: #ededf6;
  .back {
    font-size: 24px;
    color: #0b0b0b;
    font-weight: bold;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-top: -4px;
    }
  }
  .content {
    width: calc(100% - 0.9rem);
    height: calc(100% - 1.8rem);
    overflow-y: auto;
    background-color: #fff;
    padding: 0 0.45rem 0.6rem;
    box-sizing: border-box;
    margin: 0 0.45rem;
    text-align: left;
    margin-top: 0.4rem;
    font-family: 'Microsoft Yahei' !important;
    p {
      margin-left: 0 !important;
      margin-top: 10px !important;
      span {
        text-align: left;
      }
      .imgCon {
        text-align: center;
        display: block;
      }
      img {
        max-width: 90%;
      }
    }
    li {
      margin-left: 0 !important;
      span {
        text-align: left;
      }
      img {
        max-width: 90%;
      }
    }
    a {
      white-space: initial;
    }
  }
}
</style>
